import { useTranslator } from '@bluebeam/react-i18n';
import { Button } from 'components/lib';
import React, { FC } from 'react';

type Props = {
  onRemoveClick: (evt: React.MouseEvent) => void;
  id: string;
};

const RemoveBtnMarker: FC<Props> = ({ onRemoveClick, id }: Props) => {
  const { translate } = useTranslator(['buttons']);
  return (
    <div>
      <div
        id="editor-remove-btn"
        className="flex-center cursor-pointer"
        style={{ wordBreak: 'normal' }}
      >
        <Button
          size="large"
          variant="destructive"
          id={id}
          style={{ border: 'none' }}
          onClick={onRemoveClick}
        >
          <span className="color-error">{translate('buttons:remove')}</span>
        </Button>
      </div>
    </div>
  );
};

export default RemoveBtnMarker;
